export enum MedicamentoType {
  PACKAGE = 'PACKAGE',
  UNIT = 'UNIT',
  SERVICE = 'SERVICE',
  PRODUCT = 'PRODUCT'
}
